import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgDoneFull = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12 23.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11M6.926 12.163a1 1 0 1 0-1.414 1.415l3.785 3.784a1 1 0 0 0 1.414 0l7.42-7.42a1 1 0 1 0-1.414-1.414l-6.713 6.713z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgDoneFull);
export default Memo;
